import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const LOCATIONS_REQUEST = 'FETCH_LOCATIONS_REQUEST';
export const LOCATIONS_FAILURE = 'FETCH_LOCATIONS_FAILURE';
export const LOCATIONS_SUCCESS = 'FETCH_LOCATIONS_SUCCESS';

export const fetchLocations = () => {
    return function(dispatch) {
        dispatch(fetchLocationsRequest());
        return axios(apiRequestOptions(apiPath.LOCATIONS.LIST))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchLocationsSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchLocationsFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchLocationsRequest = () => {
    return {
        type: LOCATIONS_REQUEST,
    }
};

const fetchLocationsFailure = (error) => {
    return {
        type: LOCATIONS_FAILURE,
        error,
    }
};

const fetchLocationsSuccess = (data) => {
    return {
        type: LOCATIONS_SUCCESS,
        data,
    }
};